import React from "react";
import { Container, Grid } from "@mui/material";

const Members = () => {
  return (
    <div className="name-div" id="Showreel">
      <h2
        className="hr-lines1 mb-5"
        style={{ color: "darkgray", textAlign: "center" }}
        id="Home"
      >
        Our Team
      </h2>
      <Container>
        <div className="about_data">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item sm={6} md={6} lg={6} className="text-center">
              <img
                src="/Assests/KUMARAVELAN.jpg"
                className=" about-img"
                alt="img"
              />
            </Grid>
            <Grid item sm={6} md={6} lg={6}>
              <div className="hover-crd">
                <div className="person">
                  <p>KUMARAVELAN</p>
                  <p>Advisor | Business Development</p>
                </div>
              </div>
              <div className="person-description">
                <p className="gaps">
                  Kumaravelan has a Master’s degree in Business Administration
                  (MBA) and a degree in Tourism Management.
                </p>
                <p className="gaps">
                  He is an accomplished professional with over 20 years of
                  experience in the amusement park, theme park, and waterpark
                  industry.{" "}
                </p>
                <p className="gaps">
                  He possesses proficiency in various areas including budgeting,
                  business planning, operations management, and project
                  management.
                </p>
                <p className="gaps">
                  With a strong background in sales, he has honed his skills to
                  excel in his field.
                </p>

                <p className="gaps">
                  He has contributed his expertise to the development of
                  renowned parks in India such as Ramoji Film City in Hyderabad
                  and Imagica World in Mumbai, He has played a vital role in
                  building the above-mentioned parks from scratch to completion.
                </p>
                <p className="gaps">
                  Currently, Kumaravelan holds the position of CEO at Aquasplash
                  Water Park in Kinshasa, RD Congo. Africa.{" "}
                </p>
                <p className="gaps">
                  He oversees strategic direction, operations, and overall
                  management of the park.{" "}
                </p>

                <p className="gaps">
                  This role underscores his leadership abilities and his
                  capability to steer the project from the front in different
                  verticals and in different complex environments and make them
                  sail smoothly through rough industry conditions.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="about_data">
          <Grid container spacing={2} alignItems="flex-start">
            {/* IMAGE – FIRST ON MOBILE */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              order={{ xs: 1, sm: 2 }}
              className="text-center"
            >
              <img
                src="/Assests/KATHIRAVAN M.jpg"
                alt="img"
                className="img-fluid about-img"
              />
            </Grid>

            {/* CONTENT – SECOND ON MOBILE */}
            <Grid item xs={12} sm={6} md={6} lg={6} order={{ xs: 2, sm: 1 }}>
              <div className="hover-crd">
                <div className="person">
                  <p>KATHIRAVAN</p>
                  <p>Director | Business Head</p>
                </div>
              </div>

              <div className="person-description">
                <p className="gaps">
                  Kathiravan has a fervent creative mind and skills.
                </p>
                <p className="gaps">
                  He is an immensely experienced Fine Arts graduate with a major
                  in Design and Visual Communication from the College of Fine
                  Arts, University of Madras.
                </p>
                <p className="gaps">
                  Over twenty-five years of extensive involvement in content
                  development, pre-production, and production design.
                </p>
                <p className="gaps">
                  Proven track record in art direction, production design, and
                  project management.
                </p>
                <p className="gaps">
                  Managed projects across Singapore, Thailand, Philippines, UAE,
                  and China.
                </p>
                <p className="gaps">
                  Proficient in conceptualizing, budgeting, scheduling, and
                  execution.
                </p>
                <p>
                  Known for his “Go getter” mindset and “trouble shooter”
                  capability.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="about_data">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item sm={6} md={6} lg={6} className="text-center">
              <img
                src="/Assests/ROMMEL SEDDANO.jpg"
                className=" about-img"
                alt="img"
              />
            </Grid>
            <Grid item sm={6} md={6} lg={6}>
              <div className="hover-crd">
                <div className="person">
                  <p>ROMMEL SADANNO</p>
                  <p>Technical Director</p>
                </div>
              </div>
              <div className="person-description">
                <p className="gaps">
                  Rommel Sedano holds a Technical Degree in Pneumatics &
                  Hydraulics from Meralco Foundation Technical Institute and has
                  pursued other technical courses. He also has completed
                  technical degrees in Electricity and Electronics.
                  Additionally, he has a Bachelor's Degree in Computer Science
                  from the University of Saint Louis.
                </p>
                <p className="gaps">
                  Rommel Sedano is a seasoned professional with extensive
                  experience in themed environment design, fabrication, and
                  installation. He has a diverse skill set, including concept
                  illustration, master planning, architectural renderings,
                  scenic painting, faux finishes, and more.{" "}
                </p>
                <p className="gaps">
                  Rommel has also worked in branding, advertisement, and
                  production design for various projects such as in store
                  displays, events, and stage concepts. He has expertise in
                  animatronic manufacture, mechanical and automation designs,
                  and motion-based systems.
                </p>
                <p className="gaps">
                  His recent role as Production Art Director at Universal
                  Studios Beijing involved overseeing the creative direction of
                  the Jurassic World Adventure Dark Ride, integrating various
                  disciplines like animatronics, ride vehicles, and projection
                  systems. Prior to this, he served as an Art & Technical
                  Director at Silk roading (Beijing) Co. Ltd., Themetech, and
                  Thoughtful Themes Creations, Pvt. Ltd., where he contributed
                  to numerous projects across China and India.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="about_data">
          <Grid container spacing={2} alignItems="flex-start">
            {/* IMAGE – FIRST ON MOBILE */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              order={{ xs: 1, sm: 2 }}
              className="text-center"
            >
              <img
                src="/Assests/KRISHNAKUMAR.jpg"
                alt="img"
                className="img-fluid about-img"
              />
            </Grid>

            {/* CONTENT – SECOND ON MOBILE */}
            <Grid item xs={12} sm={6} md={6} lg={6} order={{ xs: 2, sm: 1 }}>
              <div className="hover-crd">
                <div className="person">
                  <p>KRISHNA KUMAR A</p>
                  <p>Executive Director</p>
                </div>
              </div>
              <div className="person-description">
                <p className="gaps">
                  Krishna Kumar A serves as the Executive Director, bringing
                  over 23 years of extensive leadership and management
                  experience across diverse organizational environments.
                </p>
                <p className="gaps">
                  With a strong academic foundation in Engineering and Business
                  Administration, he combines analytical thinking with strategic
                  foresight to drive sustainable growth and operational
                  excellence.
                </p>
                <p className="gaps">
                  In his role, Krishna Kumar provides strategic direction and
                  organizational leadership, overseeing long-term planning,
                  financial stewardship, and governance frameworks. He plays a
                  pivotal role in financial management, policy formulation, and
                  ensuring legal and regulatory compliance, safeguarding the
                  organization’s integrity and resilience.
                </p>
                <p className="gaps">
                  Known for building strong stakeholder relationships, he works
                  closely with investors, partners, and internal teams to align
                  vision with execution. His leadership philosophy emphasizes
                  transparency, accountability, and innovation, enabling the
                  organization to scale responsibly while maintaining its core
                  values.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
        {/* <div className="about_data">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item sm={6} md={6} lg={6} className="text-center">
              <img
                src="/Assests/MANIVANNANSUNDARAM.jpg"
                className=" about-img"
                alt="img"
              />
            </Grid>
            <Grid item sm={6} md={6} lg={6}>
              <div className="hover-crd">
                <div className="person">
                  <p>SIVA. KA. MANIVANNASUNDARAM</p>
                  <p>Administrative Director</p>
                </div>
              </div>
              <div className="person-description">
                <p className="gaps">
                  Siva. Ka. ManivannaSundaram is a highly experienced
                  administrative professional with 32 years of distinguished
                  service in organizational administration, legal oversight, and
                  operational management. As Administrative Director, he is
                  responsible for ensuring the smooth and efficient functioning
                  of the organization’s day-to-day operations.
                </p>
                <p className="gaps">
                  With strong academic credentials in arts and law, he oversees
                  daily operations, financial administration, and human
                  resources functions, ensuring internal systems and processes
                  are robust and compliant. He plays a key role in policy
                  development, aligning organizational practices with strategic
                  objectives.
                </p>
                <p className="gaps">
                  His expertise in legal and regulatory compliance provides the
                  organization with a solid governance framework, minimizing
                  risk and ensuring adherence to statutory and ethical
                  standards. Known for his discipline, integrity, and deep
                  institutional knowledge, Siva. Ka. ManivannaSundaram is a
                  cornerstone of administrative stability and compliance within
                  the organization.
                </p>
              </div>
            </Grid>
          </Grid>
        </div> */}
      </Container>
    </div>
  );
};

export default Members;
